exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n/* Component used through ContentTool */\n\n.view__wrapper--P9Wjf {\n\tposition: relative;\n}\n\n.view__container--1ObpZ {\n\twidth: 340px;\n\tbackground-color: #ffffff;\n\tborder: solid 1px #b8c0c6;\n\tborder-radius: 5px;\n\tbox-shadow: 0 3px 3px 0 rgba(21,45,57, .2);\n\tbox-sizing: border-box; /* external style [CT] */\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: calc(100% + 6px);\n\tright: 0;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "view__wrapper--P9Wjf",
	"container": "view__container--1ObpZ"
};